import { jsx as _jsx } from "react/jsx-runtime";
/**
 * React provider for analytics.
 *
 * Handles initialization and provides context for hooks.
 */
import { createContext, useContext, useEffect, useRef, } from "react";
import { initAnalytics } from "../client";
const AnalyticsContext = createContext(null);
/**
 * Provider component that initializes analytics.
 *
 * @example
 * ```tsx
 * <AnalyticsProvider config={{ apiKey: 'phc_xxx' }}>
 *   <App />
 * </AnalyticsProvider>
 * ```
 */
export function AnalyticsProvider({ children, config }) {
    const initializedRef = useRef(false);
    useEffect(() => {
        if (initializedRef.current)
            return;
        initAnalytics(config);
        initializedRef.current = true;
    }, [config]);
    return (_jsx(AnalyticsContext.Provider, { value: { initialized: initializedRef.current }, children: children }));
}
/**
 * Hook to access analytics context.
 */
export function useAnalyticsContext() {
    const context = useContext(AnalyticsContext);
    if (!context) {
        throw new Error("useAnalyticsContext must be used within an AnalyticsProvider");
    }
    return context;
}
//# sourceMappingURL=AnalyticsProvider.js.map